import React, { useState, useEffect } from "react";
import { useForm, FormProvider } from "react-hook-form";
import {
  AuthService,
  EventApplicationService,
  TraderUnitService,
  GlobalSettingService,
} from "../../../../services";
import { injectModels } from "../../../../redux/injectModels";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { updateBusinessProfile } from "../../../../services/BusinessProfileService";
import { routes } from "../../../../constants/routes";
import CaterUnits from "../Cater/CaterUnits";
import CaterBusinessDetails from "./CaterBusinessDetails";
import CaterPass from "../Cater/CaterPass";
import FoodHyigeneHealth from "../Cater/FoodHyigeneHealth";
import CaterTermsAndConditions from "../Cater/CaterTermsAndConditions";
import LitterBond from "../Cater/LitterBond";
import * as CONSTANTS from "../../../../redux/Models/Application/constants";
import CustomModal from "../../../../components/Modal/Modal";
import { ApplicationStatus, ApplicationType } from "../../../../constants/Enum";
import CountdownTimer from "../../../Common/CountdownTimer";
import { useParams } from "react-router-dom";
import PaymentCard from "../../../Common/PaymentCard";
import Swal from "sweetalert2";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { handleConsoleError } from "../../../../utils/common-methods";

const CaterApplicationForm = (props) => {
  const loginUser = AuthService.getLoginUser();
  const [step, setStep] = useState(1);
  const isProfileAvailable = true;
  const methods = useForm();
  const [isModalOpen, setModalOpen] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState();
  const { eventId, unitId } = useParams();
  const [appData, setAppData] = useState();
  const [stripePromise, setStripePromise] = useState(null);
  const [stripeDetails, setStripeDetails] = useState("");
  const navigate = useNavigate();

  const selectedTraderUnit = TraderUnitService.getSelectedTraderUnit() || {
    id: "",
    name: "",
  };

  const handlePrevious = () => {
    setStep((prevStep) => prevStep - 1);
  };

  const onSubmit = async (data) => {
     if (step > 6) {
          navigate(routes.ACCOUNT_APPLICATIONS);
        } else {
    if (step === 1) {
      await SaveCaterApplication(
        data?.caterApplicationFormData,
        data?.businessData,
      );
    }
    if (step === 2) {
      if (data && data?.unit) {
        const resetData = Object.fromEntries(
          Object.entries(data.unit).map(([key, value]) => {
            return [key, String(value).trim() === "" ? null : value]; // Set blank fields to null
          }),
        );
        resetData.backUPVehicle =
          resetData.backUPVehicle === true || resetData.backUPVehicle === "true"
            ? true
            : false;
        if (!resetData.backUPVehicle) {
          resetData.backUPVehicleType = null;
          resetData.bvConn1x16SingleQty = null;
          resetData.bvConn1x32SingleQty = null;
        }
        await SaveUnitDetails([resetData]);
      }
    }
    if (step === 3) {
      await SaveCaterApplication(data?.caterApplicationFormData, null);
    }

    if (step === 4) {
      await SaveDocs(data?.doc, data?.caterApplicationFormData?.id);
      await SaveDocsText(
        data?.rating,
        data?.registered,
        data?.caterApplicationFormData?.id,
      );
    }
    // term and condition
    if (step === 5) {
      setStep((prevStep) => prevStep + 1);
    }

    if (step === 6) {
      const payment = {
        id: null, // Guid?
        appId: data?.caterApplicationFormData?.id,
        eventId: data?.caterApplicationFormData?.eventId,
        traderId: data?.caterApplicationFormData?.traderId,
        userId: loginUser?.id, // Guid
        title: "Caterer Application Booking Payment", // string?
        amount: data?.payment?.amount, // string?
        applicationFee: data?.payment?.applicationFee, // string?
        connectedAccountId: data?.payment?.connectedAccountId, //"acct_1QjaTOPfU6Vw7G4t",
        buyerFee: data?.payment?.buyerFee, // string?
        processingFee: data?.payment?.processingFee,
        IsCaterer: true,
        remainingAmount: data?.payment?.remainingAmount,
        initialPaymentPer: data?.payment?.initialPaymentPer,
      };
      //payment Check
      if (payment?.connectedAccountId) {
        try {
          const stripe = await loadStripe(
            `${stripeDetails}`, // safer than hardcoding
            { stripeAccount: payment?.connectedAccountId },
          );

          setStripePromise(stripe);
        } catch (error) {
          const message = handleConsoleError(error);
          toast.error(error?.message || message);
        }
        setPaymentDetails(payment);
        setModalOpen(true);
      } else {
        toast.error(
          "Event organiser linked account is not setup to accept payments.",
        );
      }
    }
  }
  };

  const saveDocumentWrite = async (doc) => {
    try {
      const response = await EventApplicationService.writeCaterApplicationDoc(
        doc,
      );
      return response;    
    } catch (error) {
      const message = handleConsoleError(error);
      toast.error(error?.message || message);
    }
  };

  const SaveDocs = async (docs, appId) => {
    try {
      if (docs) {
         props.application.setLoading(true);
        const documents = docs.map((x) => {
          return { documentId: x.id, documentTypeId: x.documentFor };
        });
        const updatedDocs = {
          EventApplicationId: appId,
          Documents: documents,
        };
        const response = await EventApplicationService.updateCaterApplicationDocs(
          updatedDocs,
        );
        if (response?.isSuccess) {
          methods.setValue(`doc`, []);
          toast.success(response?.message);
        } else {
          toast.error(response?.message || 'Something went wrong');
        }
      }
    } catch (error) {
      const message = handleConsoleError(error);
      toast.error(error?.message || message);
    }finally {
    props.application.setLoading(false);
  }
  };

  const SaveDocsText = async (rating, registered, appId) => {
    try {
      props.application.setLoading(true);
      if (rating) {
        const docRating = {
          eventApplicationCatersId: appId,
          docTitle: CONSTANTS.CATER_RATING_DOC,
          document: rating,
        };
        await saveDocumentWrite(docRating);
      }
      if (registered) {
        const docRegistered = {
          eventApplicationCatersId: appId,
          docTitle: CONSTANTS.CATER_REGISTERED_DOC,
          document: registered,
        };
        const response = await saveDocumentWrite(docRegistered);
        if (response?.isSuccess) {
          setStep((prevStep) => prevStep + 1);
        }
      }
      props.application.setLoading(false);
    } catch (error) {
      props.application.setLoading(false);
      const message = handleConsoleError(error);
      toast.error(error?.message || message);
    }
  };

  const SaveUnitDetails = async (unitData) => {
    try {
      props.application.setLoading(true);
      let response;
      if (unitData && unitData.length > 0) {
        response = await EventApplicationService.updateCaterApplicationUnit(
          unitData,
        );
      }
      if (response?.isSuccess) {
        props.application.setLoading(false);
        toast.success(response?.message);
        setStep((prevStep) => prevStep + 1);
      } else {
        props.application.setLoading(false);
        toast.error(response?.message || 'Something went wrong');
      }
    } catch (error) {
      const message = handleConsoleError(error);
      toast.error(error?.message || message);
      props.application.setLoading(false);
    }
  };

  const SaveCaterApplication = async (
    caterApplicationFormData,
    businessdata,
  ) => {
    try {
     if (!caterApplicationFormData) {
  return;
}
      props.application.setLoading(true);
      const payload = {
        ...caterApplicationFormData,
        eventApplicationId: appData?.id,
        unitId,
        traderUnitId: selectedTraderUnit?.id,
        status: ApplicationStatus.InComplete,

        // Normalize empty string → null
        staffBuildWristband:
          caterApplicationFormData?.staffBuildWristband || null,
        siteVehiclePass: caterApplicationFormData?.siteVehiclePass || null,
        serviceVehiclePass:
          caterApplicationFormData?.serviceVehiclePass || null,
        mceWristband: caterApplicationFormData?.mceWristband || null,
      };

      const isUpdate = typeof payload?.id === "string" && payload.id.length > 3;
      const response = isUpdate
        ? await EventApplicationService.updateCaterApplication(payload)
        : await EventApplicationService.AddCaterApplication(payload);

      if (response?.isSuccess) {
        methods.setValue("caterApplicationFormData.id", response?.data?.id);
        if (businessdata) {
          await saveBusinessDetails(businessdata);
        }
        // props.application.setLoading(false);
        toast.success(response?.message);
        setStep((prevStep) => prevStep + 1);
      } else {
        // props.application.setLoading(false);
        toast.error(response?.message || 'Something went wrong.');
      }
    } catch (error) {
      // props.application.setLoading(false);
      const message = handleConsoleError(error);
      const msg = error?.message || message;

      if (msg?.toLowerCase().includes("duplicate")) {
        navigate(routes.DEFAULT);
      } else {
        toast.error(msg);
      }
    } finally {
      // 🔹 Always stop loader
      props.application.setLoading(false);
    }
  };

  const saveBusinessDetails = async (data) => {
    try {
      if (!data.countryId) {
        data.countryId = null;
      }
      data.userId = loginUser?.id;
      if (data.countryId === "") {
        data.countryId = null;
      }
      if (data.stateId === "") {
        data.stateId = null;
      }
      data.numberofemployees =
        data.numberofemployees === null ? 0 : data.numberofemployees;
      const response = await updateBusinessProfile(data);
      if (response?.isSuccess) {
        //toast.success(response?.message);
      } else {
        toast.error(response?.message || 'Something went wrong.');
      }
    } catch (error) {
      const message = handleConsoleError(error);
      toast.error(error?.message || message);
    }
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const convertDaysToSeconds = (days) => {
    if (!appData?.auctionStartDate) return 0;
    const startDate = appData?.auctionStartDate;
    const endDate = new Date(startDate);
    endDate.setDate(new Date(startDate).getDate() + days);
    const diffInMilliseconds = new Date(endDate) - new Date();
    const secondsInADay = Math.round(diffInMilliseconds / 1000); // 86400; // 1 day = 86,400 seconds
    if (secondsInADay < 0) {
      Swal.fire({
        title: "Auction Expire",
        text: "This Auction has expired. You can no longer apply.",
        icon: "warning",
        buttonsStyling: false,
      });
      navigate(routes.DEFAULT);
    }
    return secondsInADay ?? 0;
  };

  const getStripeDetails = async () => {
    try {
      const res = await GlobalSettingService.getStripeDetails();
      if (res?.isSuccess && res?.data) {
        setStripeDetails(GlobalSettingService.decrypt(res?.data?.keyValue));
      }
    } catch (error) {
      const message = handleConsoleError(error);
      toast.error(error?.message || message);
    }
  };
  useEffect(() => {  
       getStripeDetails();  
  }, []);

  useEffect(() => {
    const getApplicationDetails = async () => {
      try {
        // Validate trader unit
        // if (!selectedTraderUnit?.id || selectedTraderUnit.id.length < 3) {
        const selectedTraderUnitId = selectedTraderUnit?.id;
        if (!selectedTraderUnitId || selectedTraderUnitId.length < 3) {
          navigate(routes.DEFAULT);
          return;
        }

        if (!eventId) return;

        const res = await EventApplicationService.getEventApplicationByEventId(
          eventId,
          "C",
        );

        if (!res?.isSuccess || !res?.data?.length) return;

        const app = res?.data?.[0];
        setAppData(app);

        if (app.applicationType === ApplicationType.Turnover) {
          methods.setValue("turnOverFee", app?.amount);
        }

        methods.setValue("appType", app?.applicationType);
        methods.setValue("applicableFee", app?.amount);
      } catch (error) {
        const message = handleConsoleError(error);
        toast.error(error?.message || message);
      }
    };

    getApplicationDetails();
  }, [selectedTraderUnit?.id, eventId, methods, navigate]);

  return (
    <Elements stripe={stripePromise}>
      <React.Fragment>
        <CustomModal isOpen={isModalOpen} onClose={closeModal}>
          <PaymentCard paymentDetails={paymentDetails}></PaymentCard>
        </CustomModal>
        {isProfileAvailable === true && (
          <div>
            <section className="subscription-banner">
              <div className="container">
                <h3>Caterer Application Booking Form</h3>
              </div>
            </section>

            <section className="create-an-events">
              <div className="container">
                <section>
                  Your selected unit :: {selectedTraderUnit?.name}
                </section>
                <div className="create-steps">
                  <ul
                    className="cd-breadcrumb triangle nav nav-tabs"
                    role="tablist"
                  >
                    <li
                      role="presentation"
                      className={`step ${
                        step === 1 ||
                        step === 2 ||
                        step === 3 ||
                        step === 4 ||
                        step === 5 ||
                        step === 6
                          ? "active"
                          : ""
                      }`}
                    >
                      <span
                        aria-controls="businessdetails"
                        role="tab"
                        data-toggle="tab"
                        aria-expanded="true"
                      >
                        Details
                      </span>
                    </li>
                    <li
                      role="presentation"
                      className={`step ${
                        step === 2 ||
                        step === 3 ||
                        step === 4 ||
                        step === 5 ||
                        step === 6
                          ? "active"
                          : ""
                      }`}
                    >
                      <span
                        aria-controls="unit"
                        role="tab"
                        data-toggle="tab"
                        aria-expanded="false"
                      >
                        Pitchs
                      </span>
                    </li>
                    <li
                      role="presentation"
                      className={`step ${
                        step === 3 || step === 4 || step === 5 || step === 6
                          ? "active"
                          : ""
                      }`}
                    >
                      <span
                        aria-controls="pass"
                        role="tab"
                        data-toggle="tab"
                        aria-expanded="false"
                      >
                        Passes
                      </span>
                    </li>
                    <li
                      role="presentation"
                      className={`step ${
                        step === 4 || step === 5 || step === 6 ? "active" : ""
                      }`}
                    >
                      <span
                        aria-controls="food"
                        role="tab"
                        data-toggle="tab"
                        aria-expanded="false"
                      >
                        Documents
                      </span>
                    </li>
                    <li
                      role="presentation"
                      className={`step ${
                        step === 5 || step === 6 ? "active" : ""
                      }`}
                    >
                      <span
                        aria-controls="term-condition"
                        role="tab"
                        data-toggle="tab"
                        aria-expanded="false"
                      >
                        Terms & Conditions
                      </span>
                    </li>
                    <li
                      role="presentation"
                      className={`step ${step === 6 ? "active" : ""}`}
                    >
                      <span
                        aria-controls="food"
                        role="tab"
                        data-toggle="tab"
                        aria-expanded="false"
                      >
                        Litter Bond & Payment
                      </span>
                    </li>
                  </ul>
                  <div className="tab-content">
                    <FormProvider {...methods}>
                      <Form
                        onSubmit={methods.handleSubmit(onSubmit)}
                        noValidate
                      >
                        {appData?.applicationType > ApplicationType.Fixed &&
                          appData?.applicationType <
                            ApplicationType.Turnover && (
                            <div role="tabpanel" className="tab-pane" id="unit">
                              <div className="row">
                                <div className="col-sm-12 col-lg-6">
                                  <div className="trader-booking-f">
                                    <h3>Auction ending in :</h3>
                                    <div className="bid-100">
                                      <CountdownTimer
                                        duration={convertDaysToSeconds(
                                          appData?.auctionsDays,
                                        )}
                                      ></CountdownTimer>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        {step === 1 && (
                          <div
                            role="tabpanel"
                            className="tab-pane active"
                            id="businessdetails"
                          >
                            <CaterBusinessDetails></CaterBusinessDetails>
                          </div>
                        )}

                        {step === 2 && (
                          <div role="tabpanel" className="tab-pane" id="unit">
                            <CaterUnits></CaterUnits>
                          </div>
                        )}
                        {step === 3 && (
                          <div role="tabpanel" className="tab-pane" id="pass">
                            <CaterPass></CaterPass>
                          </div>
                        )}
                        {step === 4 && (
                          <div role="tabpanel" className="tab-pane" id="food">
                            <FoodHyigeneHealth></FoodHyigeneHealth>
                          </div>
                        )}
                        {step === 5 && (
                          <div
                            role="tabpanel"
                            className="tab-pane"
                            id="term-condition"
                          >
                            <CaterTermsAndConditions></CaterTermsAndConditions>
                          </div>
                        )}
                        {step === 6 && (
                          <div role="tabpanel" className="tab-pane" id="litter">
                            <LitterBond props={props}></LitterBond>
                          </div>
                        )}
                      </Form>
                    </FormProvider>
                  </div>
                  <div className="navigation-buttons mt-3 mb-3 px-2">
                    {step > 1 && (
                      <button type="button" onClick={handlePrevious}>
                        Previous
                      </button>
                    )}
                    {step < 6 && (
                      <button
                        type="button"
                        onClick={methods.handleSubmit(onSubmit)}
                      >
                        Save & Continue
                      </button>
                    )}
                    {step === 6 && (
                      <button
                        type="button"
                        onClick={methods.handleSubmit(onSubmit)}
                      >
                        Submit
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </section>
          </div>
        )}
        {isProfileAvailable === false && (
          <div>
            <section className="create-an-events">
              <div className="container">
                <div className="create-steps">
                  <div role="tabpanel" className="tab-pane">
                    <h3>
                      Please setup your business profile first{" "}
                      <Link to={routes.ACCOUNT_BUSINESSINFO}>Click here</Link>{" "}
                      to go to business profile
                    </h3>
                  </div>
                </div>
              </div>
            </section>
          </div>
        )}
      </React.Fragment>
    </Elements>
  );
};

export default injectModels(["application"])(CaterApplicationForm);
